import { isValidPhoneNumber } from "libphonenumber-js";

import type { AppointmentRecord } from "@/lib/types/appointment";

export type AppointmentCreateErrorCode =
  | "REQUIRED"
  | "PHONE_INVALID"
  | "SERVICE_REQUIRED";

export type AppointmentCreateErrors = {
  name?: AppointmentCreateErrorCode;
  phone?: AppointmentCreateErrorCode;
  services?: AppointmentCreateErrorCode;
};

export function validateAppointmentCreate(
  appt: AppointmentRecord | null | undefined
): AppointmentCreateErrors {
  const errors: AppointmentCreateErrors = {};
  const name = appt?.client?.name?.trim() ?? "";
  const phone = appt?.client?.phone?.trim() ?? "";
  const servicesCount = Array.isArray(appt?.services) ? appt!.services.length : 0;

  if (!name) errors.name = "REQUIRED";
  if (!phone) errors.phone = "REQUIRED";
  // Wired 2026-08-16 (the PHONE_INVALID code existed unused): per-country
  // length + prefix via libphonenumber — same rule the backend now enforces
  // on /admin-record/save, so the admin is guided inline, pre-submit. The
  // PhoneInput emits E.164 (+…), which is what isValidPhoneNumber expects.
  else if (!isValidPhoneNumber(phone)) errors.phone = "PHONE_INVALID";
  if (servicesCount <= 0) errors.services = "SERVICE_REQUIRED";
  return errors;
}

export function hasErrors(e: AppointmentCreateErrors): boolean {
  return Object.keys(e).length > 0;
}
